import * as PropTypes from 'prop-types';
import styled from 'styled-components';
import { BREAK_POINTS, FontSizes, GREY, GREY4, TRANSPARENT, LineHeights, WHITE } from '@origin-digital/helper';
import { CARD_PADDING } from '../../layout.consts';

var getBackgroundColor = function getBackgroundColor(_ref) {
  var background = _ref.background;

  switch (background) {
    case 'grey4':
      return GREY4;

    case 'transparent':
      return TRANSPARENT;

    default:
      return WHITE;
  }
};

export var Card = styled.div.withConfig({
  displayName: "Card",
  componentId: "sc-3aobcn-0"
})(["background-color:", ";padding:", "px ", "px;font-size:", "px;line-height:", "px;color:", ";", " @media only screen and (min-width:", "){padding:", "px ", "px;}@media only screen and (min-width:", "){padding:", "px ", "px;}"], getBackgroundColor, function (p) {
  return p.largeHeading ? CARD_PADDING.default.vertical.largeHeading : CARD_PADDING.default.vertical.smallHeading;
}, CARD_PADDING.default.horizontal, FontSizes.BODY, LineHeights.BODY, GREY, function (p) {
  return p.fullWidth ? "\n    width: 100%;\n    box-sizing: border-box;\n  " : '';
}, BREAK_POINTS.SM.Min, function (p) {
  return p.largeHeading ? CARD_PADDING.SM.vertical.largeHeading : CARD_PADDING.SM.vertical.smallHeading;
}, function (p) {
  return p.noLargePadding ? 0 : CARD_PADDING.SM.horizontal;
}, BREAK_POINTS.LG.Min, function (p) {
  return p.largeHeading ? CARD_PADDING.LG.vertical.largeHeading : CARD_PADDING.LG.vertical.smallHeading;
}, function (p) {
  return p.noLargePadding ? 0 : CARD_PADDING.LG.horizontal;
});
Card.propTypes = {
  largeHeading: PropTypes.bool,
  fullWidth: PropTypes.bool,
  background: PropTypes.oneOf(['grey4', 'transparent', 'white']),
  noLargePadding: PropTypes.bool
};